export const BuildInfo = {timestamp:1779736287000}
